import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { renderMarkdown } from '~/functions/markdown';
import { useListConceptsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitiesInput',
  props: {
    selectedActivityIds: {
      type: Array,
      required: true
    },
    fundImpactConceptIds: {
      type: Array,
      required: true
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useListConceptsQuery = useListConceptsQuery({
        queryInput: {
          taxonomyIds: [11]
        },
        kind: 'COMPANY',
        limit: 500,
        offset: 0
      }),
      companyConceptsResult = _useListConceptsQuery.result;
    function contributesToFundObjective(concept) {
      return concept.objectLinks.map(function (e) {
        var _e$object;
        return (_e$object = e.object) === null || _e$object === void 0 ? void 0 : _e$object.id;
      }).some(function (id) {
        var _props$fundImpactConc;
        return id !== null && id !== undefined && ((_props$fundImpactConc = props.fundImpactConceptIds) === null || _props$fundImpactConc === void 0 ? void 0 : _props$fundImpactConc.includes(id));
      });
    }
    var options = computed(function () {
      var _filter, _companyConceptsResul, _companyConceptsResul2;
      return (_filter = (_companyConceptsResul = companyConceptsResult.value) === null || _companyConceptsResul === void 0 ? void 0 : (_companyConceptsResul2 = _companyConceptsResul.listConcepts) === null || _companyConceptsResul2 === void 0 ? void 0 : _companyConceptsResul2.filter(contributesToFundObjective)) !== null && _filter !== void 0 ? _filter : [];
    });
    return {
      __sfc: true,
      props: props,
      companyConceptsResult: companyConceptsResult,
      contributesToFundObjective: contributesToFundObjective,
      options: options,
      emit: emit,
      Treeselect: Treeselect,
      renderMarkdown: renderMarkdown
    };
  }
});